import { zod4Resolver } from 'mantine-form-zod-resolver'
import { useForm } from '@mantine/form'
import { userRelationValidation } from './validation'

export const useUserRelationForm = () => {
  return useForm({
    mode: 'controlled',
    validate: zod4Resolver(userRelationValidation()),
    initialValues: {
      group: '1',
      related_id: '',
    },
    transformValues: (values) => {
      return {
        group: Number(values.group),
        related_id: Number(values.related_id),
      }
    }
  })
}

